// these schemas are established here https://www.notion.so/wingspan/fe955d2904ec47aa8f48d4aae43bc4ef?v=6fa33777de0341c093feb16515a629bb

import { IActivityContext } from "@wingspanhq/users";

export enum GrowthSourceNames {
  Partner = "Partner",
  Referral = "Referral",
  Collaborator = "Collaborator",
  Team = "Team",
  Invoice = "Invoice",
  Content = "Content",
  Enterprise = "Enterprise"
}

export interface GrowthSource {
  source: GrowthSourceNames;
  cleaned: string | undefined;
}

export const GrowthSources: { [key in GrowthSourceNames]: GrowthSource } = {
  [GrowthSourceNames.Partner]: {
    source: GrowthSourceNames.Partner,
    cleaned: "p"
  },
  [GrowthSourceNames.Referral]: {
    source: GrowthSourceNames.Referral,
    cleaned: "r"
  },
  [GrowthSourceNames.Collaborator]: {
    source: GrowthSourceNames.Collaborator,
    cleaned: "c"
  },
  [GrowthSourceNames.Team]: {
    source: GrowthSourceNames.Team,
    cleaned: "t"
  },
  [GrowthSourceNames.Invoice]: {
    source: GrowthSourceNames.Invoice,
    cleaned: "i"
  },
  [GrowthSourceNames.Content]: {
    source: GrowthSourceNames.Content,
    cleaned: undefined
  },
  [GrowthSourceNames.Enterprise]: {
    source: GrowthSourceNames.Enterprise,
    cleaned: "e"
  }
};

export interface GrowthAttributionDetails {
  growthSource: GrowthSourceNames;
  growthName?: string;
  growthUserId?: string;
}

export const isUnderWriterMember = (context: IActivityContext) => {
  if (context?.growthSourceName) {
    return context.growthSourceName === "underwriterservicesassoc";
  }
  return false;
};

export const isIAPathMember = (context: IActivityContext) => {
  if (context?.growthSourceName) {
    return context.growthSourceName === "iapath";
  }
  return false;
};

export const isPartnerLogoCoBranded = (context: IActivityContext) => {
  if (context?.growthSourceName) {
    return ["underwriterservicesassoc", "iapath"].includes(
      context.growthSourceName
    )
      ? false
      : true;
  }
  return true;
};
